<template>
  <div>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">

        <div class="col-xl-3 col-sm-6 col-12 d-flex">
          <div class="dash-count">
            <div class="dash-counts">
              <h4>{{ reportData.user_count }}</h4>
              <h5>ຈຳນວນເຄືອງນຳໃຊ້</h5>
            </div>
            <div class="dash-imgs">
              <vue-feather type="smartphone"></vue-feather>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6 col-12 d-flex">
          <div class="dash-count das1">
            <div class="dash-counts">
              <h4>{{ reportData.class_room }}</h4>
              <h5>ຫ້ອງ</h5>
            </div>
            <div class="dash-imgs">
              <vue-feather type="book"></vue-feather>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-sm-6 col-12 d-flex">
          <div class="dash-count das2">
            <div class="dash-counts">         
              <h4>{{ reportData.student_count }}</h4>
              <h5>ຈຳນວນນັກສຶກສາ</h5>
            </div>
            <div class="dash-imgs">
              <vue-feather type="users"></vue-feather>
            </div>
          </div>
        </div>
        <!-- <div class="col-xl-3 col-sm-6 col-12 d-flex">
          <div class="dash-count das3">
            <div class="dash-counts">
              <h4>170</h4>
              <h5>Sales Invoice</h5>
            </div>
            <div class="dash-imgs">
              <vue-feather type="file"></vue-feather>
            </div>
          </div>
        </div> -->
      </div>
      
      <!-- Student counts by year -->
      <div class="row mt-4">
        <div class="col-12">
          <h4 class="mb-3">ຈຳນວນນັກສຶກສາແຍກຕາມປີ</h4>
        </div>
        <template v-if="Object.keys(reportData.students_by_year || {}).length > 0">
          <div v-for="(count, year) in reportData.students_by_year" :key="year" class="col-xl-3 col-sm-6 col-12 d-flex">
            <div class="dash-count" :class="'das' + (parseInt(year) % 3 + 1)">
              <div class="dash-counts">
                <h4>{{ count }}</h4>
                <h5>ປີ {{ year }}</h5>
              </div>
              <div class="dash-imgs">
                <vue-feather type="user-check"></vue-feather>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="col-12">
          <p>ບໍ່ມີຂໍ້ມູນນັກສຶກສາແຍກຕາມປີ</p>
        </div>
      </div>
      <!-- Button trigger modal -->
    </div>
  </div>
</div>
</template>

<script>
import { basicAreaChart } from "./data";
import AdminProducts from '@/assets/json/admin-products.json'
import AdminExpired from '@/assets/json/admin-expired.json'
import DashService from '@/services/dash.service';
// import axios from 'axios'

export default {
    data() {
        return {
            basicAreaChart: basicAreaChart,
            AdminProducts: AdminProducts,
            AdminExpired: AdminExpired,
            reportData: {
                user_count: 0,
                student_count: 0,
                class_room: 0,
                students_by_year: {}
            }
        }
    },
    mounted() {
        this.fetchReportData()
    },
    methods: {
      
    async fetchReportData() {
      DashService.DashView().then((response) => {
        this.reportData = response.data
      })
    },
    showConfirmation() {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        confirmButtonClass: 'btn btn-primary',
        cancelButtonClass: 'btn btn-danger ml-1',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            confirmButtonClass: 'btn btn-success',
          });
        }
      });
    },
  },
}
</script>